export default {
  // ── index.html / Login ──────────────────────────────
  loginPlaceholder:    "Nombre",
  loginBtn:            "Iniciar sesión con Passkey",
  loginAuthenticating: "Autenticando…",
  loginEnterName:      "Por favor ingresa un nombre",
  loginFailed:         "Error al iniciar sesión",
  // ── Nombre para mostrar (Perfil) ────────────────────
  displayNameMenuLabel:    "Nombre visible",
  displayNameDialogTitle:  "Cambiar nombre visible",
  displayNameDialogDesc:   "Tu nombre visible se muestra a otros en chats y contactos. Tu nombre de usuario no cambia.",
  displayNamePlaceholder:  "ej. Anna 🌸",
  displayNameSaveBtn:      "Guardar",
  displayNameCancelBtn:    "Cancelar",
  displayNameResetBtn:     "Restablecer",
  displayNameSaved:        "Nombre visible guardado",
  displayNameReset:        "Nombre visible restablecido",
  displayNameTooLong:      "Nombre visible demasiado largo (máx. 32 caracteres).",
  displayNameInvalid:      "Nombre visible no válido.",
  displayNameSaveFailed:   "No se pudo guardar el nombre visible.",
  displayNameRateLimit:    "Demasiados cambios. Espera una hora.",
  displayNameCharCount:    (n) => `${n}/32`,
  registerHandleTaken:     (handle) => `El nombre de usuario "${handle}" ya está en uso.\n\nSi es tu cuenta: inicia sesión con tu passkey.\nDe lo contrario: elige otro nombre de usuario.`,
  registerHandleBlocked:   (handle) => `El nombre de usuario "${handle}" no está disponible actualmente.\n\nFue eliminado recientemente y está bloqueado durante 300 días. Por favor elige otro nombre de usuario.`,
  registerHandleInvalid:   "Nombre de usuario no válido.\n\nPermitido: 3–32 caracteres, solo minúsculas (a–z), dígitos (0–9) y guion bajo (_).",
  registerTooManyRequests: "Demasiados intentos de registro. Espera un minuto e inténtalo de nuevo.",
  registerFailed:          (err) => `Error al registrarse: ${err}`,
  loginHandleTaken:        (handle) => `El nombre de usuario "${handle}" ya está registrado.\n\nSi es tu cuenta: asegúrate de que tu passkey esté disponible en este dispositivo (p. ej. mediante iCloud o Google Sync) — o usa el dispositivo en el que creaste originalmente el passkey.\n\nSi no: por favor elige otro nombre de usuario.`,
  loginHandleExistsConfirm:(handle) => `El nombre de usuario "${handle}" ya está en uso.\n\nSi es tu cuenta: haz clic en OK para iniciar sesión con tu passkey.\n\nSi no: haz clic en Cancelar y elige otro nombre de usuario.`,
  loginGenericError:       (name, msg) => `Inicio de sesión fallido:\n\n${name}\n${msg}`,

  // ── inbox.html ──────────────────────────────────────
  inboxPageTitle:           "RENEX – Inbox",
  addContactHeading:        "Añadir contacto",
  guestInviteLabel:         "O: invitar a un invitado (sin cuenta)",
  createInviteLinkBtn:      "Crear link de invitación",
  addContactTitle:          "Añadir contacto",
  sendRequestTitle:         "Enviar solicitud",
  addContactPlaceholder:    "Username",
  addContactBtn:            "Enviar solicitud",
  pendingHeading:           "Solicitudes pendientes",
  contactsHeading:          "Contactos",
  deleteAccount:            "Eliminar cuenta",
  logout:                   "Cerrar sesión",
  langToggleLabel:          "Idioma",
  settings:                 "Ajustes",
  legalLabel:               "Legal",

  // ── Tabs ─────────────────────────────────────────────
  tabChats:             "Contactos & Chats",
  tabGroups:            "Grupos",
  tabContacts:          "Contactos",
  tabVoice:             "Llamadas",

  // ── Voice / Calls ────────────────────────────────────
  callIncoming:         "Llamada entrante…",
  callRinging:          "Llamando…",
  callConnecting:       "Conectando…",
  callEnded:            "Finalizada",
  callMissed:           "Perdida",
  voiceMitmFp:          "🚨 Alerta de seguridad: cifrado de audio comprometido (huella no coincide). Llamada cancelada.",
  voiceMitmSig:         "🚨 Alerta de seguridad: firma del llamante no válida. Llamada cancelada.",
  connectionDegraded:   "Conexión inestable…",
  voiceErrorNoCmk:      "Falta la clave de cifrado con este contacto. Envía primero un mensaje de texto y vuelve a intentarlo.",
  voiceErrorBusy:       "El destinatario está actualmente en otra llamada.",
  voiceErrorSignaling:  "Falló la conexión con el servidor. Inténtalo de nuevo.",
  voiceErrorIce:        "No se pudo establecer la conexión de audio (red/cortafuegos).",
  voiceErrorIncompat:   "El otro dispositivo usa una versión incompatible de la app.",
  voiceErrorPermission: "Falta el permiso del micrófono. Permítelo en los ajustes del navegador.",
  voiceErrorNoMic:      "No se encontró micrófono.",
  voiceErrorMicBusy:    "El micrófono está siendo usado por otra aplicación.",

  // ── Grupos ───────────────────────────────────────────
  groupNamePlaceholder: "Nombre del grupo",
  createGroupBtn:       "Crear grupo",
  noGroups:             "Aún no hay grupos.",
  loadingText:          "Cargando…",
  youSuffix:            " (Tú)",
  loadError:            "Error al cargar",
  memberLabel:          "(Miembro)",
  inviteBtn:            "+ Invitar",
  invitePlaceholder:    "Username…",
  alreadyMember:        (handle) => `${handle} ya es miembro.`,
  userNotFound:         (handle) => `El usuario "${handle}" no existe.`,
  notInContacts:        (handle) => `"${handle}" no está en tus contactos. Agrégalo primero como contacto.`,
  inviteFailed:         "Error al invitar: ",
  groupFull:            "El grupo está lleno (máx. 50 miembros).",
  confirmRemoveMember:  (handle) => `¿Eliminar a ${handle} del grupo?`,
  removeMemberFailed:   "Error al eliminar: ",
  youWereRemoved:       "Has sido eliminado del grupo.",
  leaveGroupBtn:        "Salir",
  confirmLeaveGroup:    (name) => `¿Salir del grupo "${name}"?`,
  leaveFailed:          "Error al salir: ",
  createGroupFailed:    "Error al crear grupo: ",
  groupDetails:         "Detalles del grupo",
  newMessage:           "Nuevo mensaje",
  noMessages:           "Sin mensajes aún",
  yesterday:            "Ayer",
  youPrefix:            "Tú: ",
  noChatYet:            "Sin chat aún",

  // ── CMK-Rotation Toasts ────────────────────────────
  cmkSelfRotateToast:   "🔁 Claves de seguridad rotadas ({n} chats)",
  cmkMirrorRotateToast: "🔁 Clave de seguridad rotada con {peer}",
  recoveryPromptToast:  "🔐 Restaurar historial — introduce frase de recuperación",
  // ── Recovery-Login (dispositivo nuevo) — spec RECOVERY.md §5.3/§6.4 ──
  recoveryLoginTitle:        "Recuperación con tu frase",
  recoveryLoginIntroAuth:    "Necesitas AMBOS: un passkey Y tu frase de 12 palabras. La frase sola no basta — solo descifra tu copia de claves. Bueno saberlo: tu passkey suele sincronizarse mediante el Llavero de iCloud o Google, así que volverá a estar en el dispositivo nuevo al iniciar sesión — o puedes usarlo desde otro dispositivo vía QR/Bluetooth.",
  recoveryLoginAuthBtn:      "🔐 Entrar con passkey",
  recoveryLoginPhraseTitle:  "Introduce tu frase",
  recoveryLoginIntroPhrase:  "Autenticación correcta. Ahora introduce tu frase de 12 palabras para restaurar tus claves.",
  recoveryDeriving:          "Descifrando…",
  recoveryLoginRecoverBtn:   "Restaurar",
  recoveryLoginDoneTitle:    "Recuperación correcta",
  recoveryLoginDoneIntro:    "Tus claves se han descifrado:",
  recoveryStatsCmks:         "Conversaciones DM",
  recoveryStatsGsks:         "Grupos",
  recoveryLoginTodoNote:     "Tus claves están restauradas — tus mensajes existentes vuelven a ser legibles en este dispositivo.",
  recoveryNotRegistered:     "Cuenta no encontrada. La recuperación necesita una cuenta existente.",
  recoveryInvalidPhrase:     "La frase no es válida (error BIP39).",
  recoveryNoBundle:          "No se encontró copia de recuperación.",
  recoveryWrongPhrase:       "Incorrecta.",
  attemptsLeft:              "intentos restantes",
  recoveryCooldown:          "Demasiados intentos incorrectos. Inténtalo de nuevo en 1 hora.",
  recoveryVerifyFailed:      "Recuperación fallida",
  updateAvailableToast: "🔄 Nueva versión disponible — recargar",

  // ── Mute / Notification-Settings ───────────────────
  mute:                 "Silenciar",
  muted:                "Silenciado",
  unmute:               "Activar notificaciones",
  muteFor:              "Silenciar durante",
  muteUntil:            "Silenciado hasta",
  muteIndefinite:       "Silenciado (manualmente)",
  mute1h:               "1 hora",
  mute8h:               "8 horas",
  mute24h:              "24 horas",
  muteForever:          "Hasta que lo reactive",
  muteMentionsOnly:     "Solo @-menciones",
  muteMentionsAndEveryone: "@-menciones + @todos",

  // ── Chat-Header-Menu (3 puntos) ─────────────────────
  moreActions:           "Más",
  removeContact:         "Eliminar contacto",
  removeContactConfirm:  "¿Eliminar contacto {peer}? El historial del chat se conserva localmente.",
  removeContactSuccess:  "{peer} eliminado",
  contactRemovedByPeer:  "{peer} te ha eliminado de sus contactos",
  contactRequestToast:   "📩 Nueva solicitud de contacto de {peer}",
  reactionToastDm:       "{emoji} {peer} ha reaccionado",
  reactionToastGroup:    "{emoji} {peer} ha reaccionado en {group}",
  captchaRequired:       "Por favor, resuelve el captcha",

  // ── Invite-Link (invitación de invitado) ───────────
  inviteByLinkTitle:     "Invitar por enlace (sin cuenta)",
  invite1to1Title:       "Invitar a alguien (1:1)",
  invite1to1Hint:        "Envía este enlace a la persona con quien quieres chatear — se une como invitado (sin cuenta).",
  inviteToGroupTitle:    "Invitar al grupo: {name}",
  inviteGroupHint:       "Envía este enlace a las personas que quieres invitar a tu grupo — chatean como invitados (sin cuenta).",
  creatingInvite:        "Creando enlace de invitación…",
  inviteCreateFailed:    "No se pudo crear el enlace de invitación",
  inviteCreateBtn:       "Crear enlace de invitación",
  serverInviteTitle:     "Enlace de invitación al servidor",
  serverInviteHint:      "Envía este enlace a personas con cuenta RENEX — así se unen al servidor. Válido 7 días.",
  inviteInvalid:         "Enlace de invitación no válido o caducado",
  inviteAlreadyMember:   "Ya eres miembro de este servidor",
  inviteJoinConfirm:     "¿Unirse al servidor «{name}»? ({count} miembros)",
  inviteJoinSuccess:     "✅ Te uniste al servidor",
  inviteJoinFailed:      "Error al unirse",
  inviteRateLimit:       "Demasiadas invitaciones — inténtalo más tarde.",
  inviteShareText:       "¡Hola! Escríbeme en RENEX — sin cuenta.",
  copy:                  "Copiar",
  copied:                "Copiado",
  copyFailed:            "No se puede copiar — selecciona el enlace manualmente",
  shareBtn:              "Compartir",
  expiresAt:             "Válido hasta",
  guestMsgLimit:         "Mensajes de invitado",
  convertingGuest:       "Convirtiendo cuenta de invitado…",
  convertSuccess:        "Cuenta de invitado reclamada ✓",
  guestConvertedToast:   "👤 {old} ahora es {new}",
  sysGuestConvertNotice: "Un invitado se registró. Los mensajes cifrados anteriores siguen siendo ilegibles para los demás participantes.",
  sysGuestExpiryWarn: "Este acceso de invitado caduca en {n} días. Crea una cuenta para conservar el chat y las claves.",
  sysGuestNowReal:       "👤 {old} ahora es @{new}",
  sysNowAdmin:           "👑 {user} ahora es Admin",
  guestJoinedToast:      "👤 {handle} se unió",
  inviteAcceptedToast:   "🤝 {handle} aceptó la invitación",
  inviteAcceptFailed:    "No se pudo aceptar la invitación",
  inviteRevokeBtn:       "Revocar",
  inviteRevokeConfirm:   "¿Revocar este link de invitación? Quedará inválido inmediatamente.",
  inviteRevokeSuccess:   "Link de invitación revocado",
  inviteRevokeFailed:    "No se pudo revocar",
  tabInvites:            "Invitaciones",
  invitesEmpty:          "Aún no hay enlaces de invitación activos. Crea uno arriba.",
  inviteUses:            "Usos",
  inviteNeverExpires:    "sin límite",
  inviteExpired:         "caducado",
  inviteInviterLeft:     "El invitador ya no es miembro de esta conversación.",
  inviteByLinkLabel:     "🔗 Invitar con link",

  // ── Attachments (Photo/File) ───────────────────────
  attachPhoto:             "Adjuntar foto",
  attachFile:              "Adjuntar archivo",
  attachMenuTitle:         "Añadir adjunto",
  attachPhotoVideo:        "Foto",
  attachPhotoLibrary:      "Galería",
  attachTakePhoto:         "Tomar foto",
  attachDocument:          "Documento",
  attachGif:               "GIF",
  dropToAttach:            "Suelta el archivo para adjuntar",
  gifNoResults:            "Sin resultados.",
  gifRateLimit:            "Demasiadas búsquedas — espera un momento.",
  gifNotConfigured:        "Búsqueda de GIF no disponible.",
  gifSearchFailed:         "Búsqueda de GIF fallida.",
  pickGif:                 "Elegir GIF",
  poweredByGiphy:          "Powered by GIPHY",

  // ── PWA Install ────────────────────────────────────
  pwaInstallTitle:         "Instalar como app",
  pwaInstallSub:           "Más rápido, ventana propia, siempre disponible.",
  pwaInstallBtn:           "Instalar",
  pwaInstallMenuItem:      "Instalar como app",
  dismiss:                 "Cerrar",
  pwaIosStep1:             "Toca el botón Compartir en la parte inferior de Safari",
  pwaIosStep2:             "Elige \"Añadir a pantalla de inicio\" en el menú.",
  pwaIosStep3:             "Confirma con \"Añadir\" arriba a la derecha.",
  pwaIosVideoAlt:          "Vídeo: instalar RENEX en Safari mediante Compartir → \"Añadir a pantalla de inicio\"",
  pwaMacStep1:             "En Safari, abre el menú \"Archivo\".",
  pwaMacStep2:             "Elige \"Añadir al Dock…\"",
  pwaMacStep3:             "Confirma en el diálogo.",
  pwaMacRequirementHint:   "Requiere Safari 17 o más reciente (macOS Sonoma+).",
  pwaUnsupportedHint:      "Tu navegador no permite la instalación directa. Prueba Chrome, Edge o Safari.",

  // ── Landing Hero (Statement-first) ─────────────────
  heroPrefix:             "Tú tienes",
  heroAccent:             "pulso",
  heroLine2:              "Los bots no.",
  heroSub:                "RENEX es el mensajero para humanos — solo passkey, cifrado de extremo a extremo, sin rastreo. Muévete: ese es tu pulso.",
  heroCta:                "Empezar →",
  heroBack:               "← Atrás",
  heroKicker:             "Comunicación humana",
  heroOpenSource:         "Código abierto · en GitHub",
  showcaseTitle:          "Así se ve RENEX",
  showcaseSub:            "Un chat real — con Pulse. No solo ves palabras, ves que hay un humano al otro lado.",
  showcaseAlt:            "App RENEX — chat 1:1 con Pulse activo",

  // ── Landing Marketing ──────────────────────────────
  landingSectionTitle:    "Hecho para humanos, no para bots.",
  landingSectionSub:      "No verificamos tu humanidad — hacemos que la automatización no sea rentable.",
  featurePasskeyTitle:    "🔑 Login Passkey-Native",
  featurePasskeyDesc:     "Inicia sesión con tu passkey — Face ID, Touch ID, PIN o llave física (YubiKey). Sin email, sin teléfono, sin contraseña. Nada que pueda filtrarse.",
  featureE2eTitle:        "🔒 Cifrado de extremo a extremo",
  featureE2eDesc:         "Tus mensajes se cifran en tu dispositivo. Ni siquiera nosotros podemos leerlos — el servidor solo ve ciphertext, nunca texto plano.",
  featureBotResistantTitle: "🤖 Resistente a bots",
  featureBotResistantDesc:  "No verificamos tu humanidad — simplemente hacemos que el spam sea demasiado caro. Operar miles de bots exigiría miles de dispositivos reales, biometría real, relaciones reales. Los humanos siguen accesibles, los bots se rinden.",
  featureGuestTitle:      "🔗 Acceso de invitado",
  featureGuestDesc:       "Comparte un enlace para el primer contacto — tu amigo chatea al instante, sin registro. Para conversaciones duraderas se crea después un passkey propio.",
  featureCallsTitle:      "🎙️ Llamadas sin nube estadounidense",
  featureCallsDesc:       "Tus llamadas van directamente entre los dispositivos. Si no es posible, usamos nuestro propio servidor relay en Alemania — sin nube estadounidense, sin rastreadores en medio.",
  featureZeroTrackTitle:  "🛡️ Cero rastreo",
  featureZeroTrackDesc:   "Sin anuncios. Sin píxeles de rastreo. Sin perfiles de marketing. Solo datos técnicos de diagnóstico nos ayudan a corregir errores — nunca podemos leer el contenido de tus mensajes.",
  landingFooterCopy:      "© 2026 RENEX",

  // ── Manifesto ──────────────────────────────────────
  manifestoLabel:          "Manifiesto",
  landingManifestoTitle:   "Por qué existe RENEX",
  landingManifestoBody:    "Internet se ahoga en bots, las plataformas venden tu atención, la IA imita a las personas. RENEX es el contramovimiento: un lugar de personas, para personas. Lee lo que defendemos.",
  landingManifestoCta:     "Leer el Manifiesto →",

  // ── Pulse (Phase 6.5) ──────────────────────────────
  pulseOn:                 "Activar Pulse",
  pulseOff:                "Desactivar Pulse",
  pulseHintText:           "Pulse — nota cuándo alguien está realmente ahí. Toca para activar.",
  pulsePermTitle:          "Activar Pulse",
  pulsePermBody:           "RENEX usa el movimiento sutil de tu dispositivo para hacer visible tu presencia a la otra persona.",
  pulsePermPoint1:         "Totalmente en tu dispositivo",
  pulsePermPoint2:         "No se guarda nada",
  pulsePermPoint3:         "Solo lo ve la otra persona",
  pulsePermHint:           "iOS pedirá permiso de movimiento en el siguiente paso.",
  pulsePermAllow:          "Permitir →",
  pulsePresentNow:         "aquí ahora",
  nodTooltip:              "Toca para saludar 👋",

  attachmentTooLarge:      "Archivo demasiado grande (máx. 10 MB).",
  attachmentMimeBlocked:   "Tipo de archivo no permitido.",
  attachmentExtBlocked:    "Extensión no permitida.",
  attachmentRateLimit:     "Demasiadas cargas — espera un momento.",
  attachmentUploadFailed:  "Error al subir.",
  attachmentGone:          "Archivo ya no disponible.",
  attachmentForbidden:     "Sin acceso al archivo.",
  attachmentLoadFailed:    "No se pudo cargar el archivo.",
  attachmentLocked:        "esperando clave",
  loadingPhoto:            "Cargando foto…",
  openPhoto:               "Abrir foto",
  downloadBtn:             "Descargar",
  downloadFailed:          "Error al descargar.",

  // ── Device-Limit-Modal ─────────────────────────────
  deviceLimitTitle:        "Límite de dispositivos alcanzado",
  deviceLimitMessage:      "Estás usando {current}/{max} dispositivos. Gestiona tus dispositivos en Perfil → Dispositivos y elimina uno antiguo para añadir este.",
  deviceLimitOkBtn:        "Entendido",

  // ── Toasts de dispositivos (VISION §6 visibilidad multi-dispositivo) ───
  deviceAddedSelfToast:    "📱 Nuevo dispositivo añadido. Si no fuiste tú — elimínalo inmediatamente en Perfil → Dispositivos.",
  deviceAddedPeerToast:    "📱 Un contacto ha añadido un nuevo dispositivo.",
  deviceRevokedSelfToast:  "🔒 Dispositivo eliminado — las claves se están rotando.",
  deviceRevokedPeerToast:  "🔒 Un contacto ha eliminado un dispositivo — claves rotadas.",
  deviceAutoRevokedSelfToast: "🧹 Dispositivo inactivo eliminado automáticamente (30 días sin conexión).",
  deviceAutoRevokedPeerToast: "🧹 El dispositivo inactivo de un contacto fue eliminado automáticamente.",

  // ── Bandeja de grupos + Create-Modal (Phase 1C i18n) ─
  noGroupsYet:          "Aún no hay grupos",
  members:              "miembros",
  createGroupTitle:     "Crear grupo",
  groupNameHint:        "Introduce un nombre para el grupo (2–50 caracteres).",
  selectMembersTitle:   "Seleccionar miembros",
  selectMembersHint:    "Elige entre tus contactos.",
  selectMembersHintOptional: "Elige entre tus contactos — opcional. También puedes crear el grupo vacío e invitar más tarde.",
  noContactsCreateEmpty: "Sin problema — crea el grupo vacío e invita más tarde por enlace o con 'Añadir miembros'.",
  createEmptyGroupBtn:  "Crear grupo vacío",
  selected:             "seleccionados",
  noContactsToAdd:      "No hay contactos disponibles.",
  addContactsFirst:     "Añade contactos primero.",
  searchContactsPlaceholder: "Buscar contactos…",
  noContactsMatch:      "No se encontraron contactos.",
  groupCreateFailed:    "Error al crear el grupo",
  // ── Add-Members-Modal ──
  addBtn:               "Añadir",
  noContactsYet:        "Aún no tienes contactos.",
  alreadyMemberLabel:   "Ya está dentro",
  notInContactsHint:    "¿No está en tus contactos?",
  inviteByLinkBtn:      "Invitar por enlace",
  addMembersPartial:    "{ok} añadidos, {fail} fallidos",
  addMembersAllFailed:  "Error al añadir",
  backBtn:              "Atrás",

  // ── Menú de chat (3 puntos, submenús deslizantes) ─────
  notifications:           "Notificaciones",
  notificationsOn:         "Activadas",
  muteIndefiniteShort:     "∞",
  autoDeleteLabel:         "Auto-Delete",
  autoDeleteOff:           "Desactivado",
  autoDeleteActive:        (label) => `✅ Auto-Delete activo: ${label}`,
  autoDeleteDisabled:      "✅ Auto-Delete desactivado",
  autoDeleteSet:           (label) => `✅ Auto-Delete: ${label}`,
  autoDeleteProposal:      (label) => `📤 Propuesta enviada: ${label}`,
  autoDeleteProposalIncoming: "propone Auto-Delete:",
  autoDeleteWaitingForPeer: "Esperando confirmación:",
  cmkPendingBanner:        "Algunos mensajes siguen cifrados. ",
  cmkPendingBannerSuffix:  "debe conectarse brevemente — la clave faltante se cargará automáticamente.",
  cmkPendingBannerGroup:   "Algunos mensajes siguen cifrados. En cuanto los remitentes se conecten brevemente, la clave faltante se cargará automáticamente.",
  autoDeleteSetByPeer:     "estableció Auto-Delete:",
  autoDeleteDisabledByPeer: "desactivó Auto-Delete.",
  autoDeletePending:       "Pendiente",
  autoDeleteDmHint:        "Ambos deben aceptar. Se enviará una propuesta al contacto.",
  autoDeleteGroupHint:     "Cualquier miembro puede cambiar. Todos reciben un mensaje del sistema.",
  autoDeleteOneDay:        "24 horas",
  autoDeleteOneWeek:       "7 días",
  autoDeleteThirtyDays:    "30 días",
  accept:                  "Aceptar",
  decline:                 "Rechazar",
  addMembers:              "Añadir miembros",
  addMembersPrompt:        "Introduce un handle (p. ej. anna4):",
  memberAdded:             "Miembro añadido",
  memberAddFailed:         "No se pudo añadir el miembro",
  renameGroup:             "Renombrar grupo",
  renameGroupPrompt:       "Nuevo nombre del grupo:",
  groupRenamed:            "Grupo renombrado",
  groupRenameFailed:       "No se pudo renombrar",
  removeMemberLabel:       "Eliminar miembro",
  removeMemberConfirm:     "¿Eliminar a @{h} del grupo?",
  memberRemoved:           "Miembro eliminado",
  noOtherMembers:          "No hay otros miembros",
  leaveGroup:              "Salir del grupo",
  leaveGroupConfirm:       "¿Salir realmente del grupo?",
  groupLeft:               "Has salido del grupo",
  membersHeading:          "Miembros",
  groupMembersTitle:       "Miembros",
  groupMembersShow:        "Ver miembros",
  roleAdmin:               "Admin",
  youSuffix:               "Tú",
  loadingMembers:          "Cargando miembros…",
  loadMembersFailed:       "Error al cargar miembros",

  // ── Mensajes de chat ──────────────────────────────────
  decryptPending:         "🔒 Descifrando mensaje…",
  decryptFailed:          "🔒 No se pudo descifrar el mensaje",
  decryptFailedHint:      "Clave no disponible — es probable que una parte se haya registrado de nuevo.",
  decryptFailedOwn:       "🔒 Ya no puedes descifrar este mensaje",
  decryptFailedOwnHint:   "La clave se perdió. Solicita una nueva clave en un mensaje de {peer}.",
  decryptFailedOwnGroupHint:"Tu clave de grupo se perdió. Los mensajes antiguos no se podrán leer — los nuevos funcionarán.",
  decryptFailedGroupHint: "Falta la clave de {peer}. Pulsa 'Solicitar clave' para obtenerla.",
  decryptRetryBtn:        "🔄 Solicitar nueva clave",
  decryptRetryAgain:      "🔄 Solicitar de nuevo",
  decryptRetrySent:       "🔁 Nueva clave solicitada — el mensaje podría descifrarse pronto",
  decryptRetryFailed:     "⚠️ No se pudo solicitar la clave — inténtalo más tarde",
  decryptRetryPending:    "⏳ Solicitando…",
  decryptRetrySuccess:    "✅ Clave solicitada",
  decryptRetrySuccessHint:"Los mensajes nuevos volverán a ser legibles. Los mensajes antiguos cifrados con claves perdidas no se pueden recuperar.",
  decryptRetryErrorBtn:   "↻ Intentar de nuevo",
  decryptRetryErrorHint:  "La solicitud de clave falló. Comprueba la conexión e inténtalo de nuevo.",
  decryptRetryPeerOfflineHint:"{peer} no está disponible en este momento. Pide a {peer} que abra la app y vuelve a intentarlo.",
  decryptRetryPeerOfflineToast:"⚠️ {peer} no disponible",
  authorityOfflineHint:   "⚠️ {peer} no está disponible en este momento. Tus mensajes se entregarán cuando {peer} vuelva a estar conectado.",
  groupMembersOfflineHint:"ℹ️ {count} miembro(s) no disponible(s) en este momento. Tus mensajes se entregarán cuando vuelvan a estar conectados.",
  resetKeysLabel:         "🔑 Restablecer claves de cifrado",
  resetKeysConfirm:       "¿Restablecer las claves de cifrado de este chat?\n\nSoluciona problemas cuando los mensajes no se pueden descifrar. Los mensajes antiguos permanecerán ilegibles.",
  resetKeysDone:          "🔁 Claves restablecidas — los nuevos mensajes se cifrarán con una clave nueva",
  resetKeysFailed:        "⚠️ No se pudieron restablecer las claves — inténtalo de nuevo",
  resetKeysRemote:        "🔁 La otra parte restableció las claves — restableciendo sesión segura…",
  guestConvertNotice:     "🔒 Los mensajes de tu sesión de invitado no se pueden mostrar después del registro",
  messageExpired:         "⏱ Mensaje eliminado automáticamente",
  deleteMessageTitle:     "Eliminar mensaje",
  confirmDeleteMessage:   "¿Eliminar mensaje?",
  statusDelivered:        "Entregado",
  statusSent:             "Enviado",
  statusSending:          "Enviando…",
  statusEdited:           "(editado)",
  messageDeleted:         "🗑️ Mensaje eliminado",
  noPeerKey:              "🔐 El contacto aún no tiene clave pública",

  // ── Delete-Account-Dialog ───────────────────────────
  deleteAccountDialogTitle:   "Eliminar cuenta",
  deleteAccountDialogBody:    "Esta acción es irreversible. Todos los mensajes y contactos serán eliminados.<br><br>Ingresa tu nombre de usuario para confirmar:",
  deleteAccountPlaceholder:   "Tu username",
  cancelBtn:                  "Cancelar",
  deleteAccountConfirmBtn:    "Eliminar cuenta",
  deleteAccountFailed:        "Error al eliminar",
  daWipeMessages:             "Todos los mensajes + adjuntos",
  daWipeContacts:             "Todos los contactos (la otra parte verá «Cuenta eliminada»)",
  daWipeGroups:                "Serás eliminado de todos los grupos",
  daWipeDevices:              "Todos los dispositivos cerrarán sesión",
  daWipePasskeys:             "Todas las passkeys",
  daWipeBackup:               "Copia de seguridad en el servidor",
  daHandleLocked:             "Usuario bloqueado durante 300 días",

  // ── Footer ───────────────────────────────────────────
  footerImprint:              "Aviso legal",
  footerPrivacy:              "Privacidad",
  footerTerms:                "Términos",
  footerFeedback:             "Comentarios",
  footerPress:                "Prensa",

  // ── Terms Consent ─────────────────────────────────────
  consentPrefix:              "Acepto los",
  consentAnd:                 "y la",
  consentTerms:               "Términos",
  consentPrivacy:             "Política de privacidad",
  consentSuffix:              ".",
  consentRequired:            "Por favor acepta los Términos y la Política de privacidad",

  // ── inbox.js (dynamic strings) ───────────────────────
  cryptoInitFailed:       "No se pudo inicializar la criptografía",
  noContacts:             "Aún no hay contactos",
  noPendingRequests:      "No hay solicitudes pendientes",
  // ── Member-Actions-Modal ──
  openDm:                 "Mensaje directo",
  notInContactsYet:       "Aún no está en tus contactos.",
  requestContactBtn:      "Solicitar como contacto",
  hasPendingRequestIn:    "quiere añadirte como contacto.",
  requestPendingHint:     "⏳ Solicitud enviada — esperando confirmación.",
  cancelRequestBtn:       "Retirar solicitud",
  guestNoActions:         "Los invitados no pueden añadirse como contactos.",
  openMemberActions:      "Mostrar acciones",
  maContactAccepted:      "Contacto aceptado",
  maAlreadyContact:       "Ya está en tus contactos",
  maAlreadyPending:       "Solicitud ya pendiente",
  maRequestSent:          "Solicitud enviada ✓",
  maRequestRejected:      "Solicitud rechazada",
  maRequestCancelled:     "Solicitud retirada",
  maRequestFailed:        "Error en la solicitud",
  maUserNotFound:         "Usuario no encontrado",
  maAccountDeleted:       "Cuenta eliminada",
  maRejectConfirm:        "¿Rechazar esta solicitud?",
  maCancelConfirm:        "¿Retirar solicitud?",
  loadContactsFailed:     "Error al cargar los contactos",
  requestSent:            " (solicitud enviada)",
  requestWantsToConnect:  "quiere conectarse",
  requestWithdraw:        "Retirar",
  acceptBtn:              "Aceptar",
  rejectBtn:              "Rechazar",
  accountDeleted:         " (cuenta eliminada)",
  removeFromList:         "Eliminar de la lista",
  handleMismatch:         "El nombre de usuario no coincide",
  contactRequestFailed:   "Error al enviar la solicitud",
  contactRequestAccountDeleted: "Esta cuenta ya no existe",
  removeContactFailed:    "No se pudo eliminar el contacto",
  confirmRemoveContact:   (handle) => `¿Eliminar el contacto ${handle}?`,
  closeBtn:               "Cerrar",
  linkCopied:             "¡Link copiado!",
  dmInviteSubLabel:       "Invitación DM (único uso)",
  linkCopiedInfo:         "Link copiado — válido 48h, máx. 20 mensajes por invitado",
  linkCopiedClipboard:    (url) => `Chatea conmigo en Renex (disponible 48h):\n${url}`,
  linkCopiedClipboardDm:  (url) => `Escríbeme en Renex (disponible 48h, enlace único):\n${url}`,
  linkCreateFailed:       "No se pudo crear el link",
  inviteLinkCreate:       "Crear link de invitación",
  doneBtn:                "Listo",
  someInvitesFailed:      "Algunas invitaciones fallaron:",

  // ── chat/index.html ──────────────────────────────────
  chatPageTitle:        "Chat",
  chatStartupError:    "No se pudo cargar el chat. Por favor, recarga la página.",
  reloadBtn:           "Recargar",
  messagePlaceholder:   "Mensaje…",
  sendBtn:              "Enviar",
  newMessagesSuffix:    " mensajes nuevos ↓",
  replyingTo:           "Respondiendo a",
  cancel:               "Cancelar",
  editingMessage:       "Editando mensaje",
  confirmDelete:        "¿Eliminar este mensaje?",
  deleteFailed:         "Error al eliminar",
  editFailed:           "Error al editar",
  pttToggle:            "Pulsar para hablar",
  pttHold:              "Mantén pulsado para hablar (Espacio)",
  pttSpeaking:          "Grabando…",
  reconnecting:         "Reconectando…",

  // ── chat.js (dynamic strings) ────────────────────────
  noChatPartner:      "Ningún contacto seleccionado",
  chatWith:           (user) => `Chat con ${user}`,
  sendFailed:         "No se pudo enviar el mensaje",
  sendFailedError:    (err) => `⚠️ Error al enviar: ${err}`,
  unknownError:       "Error desconocido",
  renameFailed:       "Error al renombrar: ",
  editFailed:         "Error al editar: ",
  deleteFailed:       "Error al eliminar: ",
  fileLabel:          "Archivo",
  photoLabel:         "📷 Foto",
  maxLengthReached:   (max) => `Máximo de ${max} caracteres alcanzado`,
  charCounter:        (len, max) => `${len} / ${max} caracteres`,
  pleaseWait:         "Por favor espera un momento…",

  // ── Crear grupo Popup ────────────────────────────────
  createGroupLabel:    "Crear grupo",
  nextBtn:             "Siguiente →",
  invitePeopleLabel:   "Invitar personas",
  onlyContactsWarning: "Solo tus propios contactos pueden ser invitados",
  orSeparator:         "o",
  guestInviteLinkBtn:  "🔗 Crear link de invitación para invitados",
  createGroupFinish:   "Crear grupo",
  filterPlaceholder:   "Filtrar…",
  noContactsFound:     "Sin resultados",
  noContactsYet:       "Sin contactos aún",

  // ── Miembros ─────────────────────────────────────────
  membersLabel:        (n) => `${n} miembros`,
  newGroup:            "nuevo grupo",
  groupInviteToast:    (name) => `Fuiste invitado al grupo "${name}"`,
  invitedByPrefix:     (by) => `De: ${by}`,

  // ── Menú de chat ─────────────────────────────────────
  notificationsLabel:    "Notificaciones",
  notificationsOn:       "Activadas",
  notificationsOff:      "Desactivadas",
  notifAll:              "🔔 Todas las notificaciones",
  notifMentionsEveryone: "@Mentions + @everyone",
  notifMentionsOnly:     "@Mentions",
  notifMuted:            "🔕 Silenciado",
  notifMuteFor1h:        "⏱ Silenciar 1h",
  notifMuteFor8h:        "⏱ Silenciar 8h",
  notifMuteFor24h:       "⏱ Silenciar 24h",
  notifLevelMentions:    "@Mentions",
  notifLevelMentionsAll: "@Mentions + @all",
  notifTimedSuffix:      (time) => `Silenciado (${time})`,
  renameGroupLabel:      "✏️ Renombrar grupo",
  createInviteLinkLabel: "🔗 Crear link de invitación",

  // ── Banner de invitado ────────────────────────────────
  guestLabel:              "Invitado",
  registerToAddContacts:   "Regístrate para añadir contactos",
  guestMsgLimit:           "⚠️ Límite de mensajes alcanzado — ¡regístrate para seguir escribiendo!",
  // GuestBanner (info de sesión sobre el chat)
  guestSessionExpiresIn:   "La sesión caduca en",
  guestSessionExpired:     "Sesión de invitado caducada",
  guestDaysLeft:           "{n} días",
  orgInviteTitle:          "Invitaciones ciudadanas (organización)",
  orgInviteHint:           "Invitaciones de larga duración — entrégalas como tarjeta QR o envíalas por carta. Una invitación = una persona.",
  orgDaysLabel:            "Validez (días)",
  orgCountLabel:           "Cantidad",
  orgLabelsLabel:          "Referencias de destinatarios (opcional, una por línea — determina la cantidad)",
  orgLabelsPlaceholder:    "Socio Müller\nPaciente 0042\n…",
  orgCreateBtn:            "Crear {n} invitación(es)",
  orgCodeToggle:           "Exigir código de activación (autenticación del destinatario)",
  orgCodeHint:             "El código se muestra aquí UNA sola vez — entréguelo por separado (segunda carta, teléfono, en persona). RENEX nunca lo guarda en claro.",
  orgCsvBtn:               "CSV",
  orgResultsTitle:         "Recién creadas",
  orgExistingTitle:        "Invitaciones existentes",
  orgNoInvites:            "Aún no hay invitaciones.",
  orgStatusOpen:           "abierta",
  orgStatusConsumed:       "canjeada",
  orgStatusActive:         "activa",
  orgStatusExpired:        "caducada",
  orgStatusConverted:      "cuenta creada",
  inviteCitizenTitle:      "Invitar ciudadano",
  orgBridgeHint:           "Los ciudadanos no tienen cuenta RENEX — no necesitan un handle.",
  orgBridgeBtn:            "Crear invitación",
  guestMessagesLeft:       "Mensajes restantes",
  guestMsgLimitReached:    "Límite de mensajes alcanzado",
  guestCreateAccount:      "Crear cuenta",
  guestJoined:         (name) => `👤 Te uniste como <strong>${name}</strong>`,
  expired:             "Expirado",
  guestLimitReached:   "Has usado todos tus mensajes de invitado. Crea una cuenta gratuita con Passkey para seguir leyendo y escribiendo — en segundos, sin contraseña.",
  guestExpired:        "Tu acceso de invitado ha expirado. Crea una cuenta gratuita con Passkey para seguir leyendo y escribiendo — en segundos, sin contraseña.",
  guestLimitTitle:     "Límite de mensajes alcanzado",
  guestExpiredTitle:   "Acceso de invitado expirado",
  dropToSend:          "Soltar archivo para enviar",
  dropUnsupported:     "Tipo de archivo no compatible",
  sendCooldown:        "Enviando demasiado rápido — inténtalo de nuevo",
  timeRemaining:       "restante",
  msgsRemaining:       "mensajes restantes",
  convertToPasskey:    "Iniciar sesión con Passkey",

  // ── Lista de miembros (Chat) ──────────────────────────
  contactAdded:        "✓ Contacto",
  requestContact:      "+ Solicitar",
  requestPending:      "✓ Pendiente",
  requestSentConfirm:  "✓ Enviado",
  errorLabel:          "✗ Error",

  // ── Diversos ─────────────────────────────────────────
  cancelTitle:         "Cancelar",
  networkError:        "⚠️ Error de red",
  groupNameLabel:      "Nombre del grupo",

  // ── Modal GIF ────────────────────────────────────────
  gifSearchPlaceholder: "Buscar GIF…",
  gifTitle:             "Buscar GIF",
  gifSearching:         "Buscando…",
  photoTitle:           "Enviar foto",
  fileTitle:            "Enviar archivo",

  // ── Página de invitación (join) ───────────────────────
  invitePageTitle:         "RENEX – Invitación",
  checkingInvite:          "Verificando invitación…",
  invitedByText:           (by) => `Fuiste invitado por <strong>${by}</strong>`,
  accessFor24h:            "Acceso por <strong>24 horas</strong> — luego guarda con Passkey",
  maxMessages:             "Hasta <strong>20 mensajes</strong> como invitado",
  e2eEncrypted:            "Cifrado de extremo a extremo",
  joinAsGuestBtn:          "Unirse como invitado",
  loginAndJoinBtn:         "Iniciar sesión y unirse",
  invalidInviteTitle:      "Invitación inválida",
  inviteExpiredDefaultMsg: "Este link de invitación ha expirado o ya fue utilizado.",
  goHomeBtn:               "Ir al inicio",
  noTokenMsg:              "Este link es inválido.",
  inviteExpiredReason:     "Este link de invitación ha expirado.",
  inviteAlreadyUsed:       "Este link ya fue utilizado.",
  inviteAlreadyUsedDm:     "Este enlace de invitación ya fue utilizado. Cada enlace DM solo puede usarse una vez.",
  inviteNotFound:          "Este link no existe.",
  joiningText:             "Uniéndose…",
  captchaRequired:         "Por favor, completa la verificación de seguridad primero.",
  captchaFailed:           "Verificación de seguridad fallida. Por favor, inténtalo de nuevo.",
  joinErrorDefault:        "Error al unirse.",
  successRedirecting:      "¡Éxito! Redirigiendo…",
  connectionError:         "Error de conexión",
  checkConnection:         "Por favor, verifica tu conexión a internet.",
  joinErrorTitle:          "Error al unirse",
  joinErrorRetry:          "Por favor, inténtalo de nuevo.",
  networkErrorRetry:       "Error de red. Por favor, inténtalo de nuevo.",

  // ── Gestión de Dispositivos (Multi-Dispositivo) ──────
  devicesLabel:            "Dispositivos",
  devicesTitle:            "Gestionar dispositivos",
  devicesActive:           "dispositivos activos",
  devicesEmpty:            "No hay dispositivos activos.",
  devicesLoadFailed:       "No se pudieron cargar los dispositivos",
  deviceCurrent:           "ACTUAL",
  deviceUnnamed:           "Dispositivo sin nombre",
  deviceLastSeen:          "última vez",
  deviceSyncing:           "sincronizando…",
  deviceLogoutBtn:         "Cerrar sesión",
  deviceRevokeBtn:         "Eliminar",
  deviceLogoutConfirm:     "¿Finalizar esta sesión?",
  deviceRevokeConfirm:     "¿Eliminar dispositivo? Esta acción es permanente. Todas las conversaciones se re-cifrarán con nuevas claves.",
  deviceRevokeFailed:      "Error al eliminar",
  deviceAutoRevokeHint:    "Los dispositivos se eliminan automáticamente tras 30 días de inactividad.",
  addDeviceBtn:            "+ Añadir dispositivo",
  addDeviceLimitTooltip:   "Límite alcanzado. Elimina un dispositivo o pasa a Pro.",
  addDeviceTitle:          "Añadir dispositivo",
  addDeviceIntro:          "Sigue estos pasos — tu Passkey permanece seguro en este dispositivo.",
  addDeviceStep1:          "En el nuevo dispositivo, abre renex.id.",
  addDeviceStep2:          "Introduce tu handle e inicia sesión — el navegador mostrará allí un código QR.",
  addDeviceStep3:          "Escanea ese código QR con la cámara de este dispositivo.",
  addDeviceStep4:          "Confirma con Touch-ID / Face-ID — listo.",
  addDeviceConvenienceTip: "💡 Sugerencia: escanea este QR con la cámara de tu nuevo dispositivo para abrir renex.id directamente (ahorra escribir la URL).",
  addDeviceHint:           "🔒 Tu Passkey permanece en este dispositivo — nunca se transfiere. El nuevo dispositivo crea su propio Passkey, que tu Passkey existente confirma mediante el escaneo del QR.",
  addDeviceAppleNotice:    "✨ En dispositivos Apple con un mismo ID de iCloud aparece automáticamente una notificación de confirmación — en ese caso puedes saltar el paso 3.",
  addDeviceQrError:        "No se pudo generar el código QR.",
  addDeviceCloseBtn:       "Entendido",

  // ── Servers (Phase 3A) ───────────────────────────────
  serversLabel:                       "Servidores",
  serversEmpty:                       "Aún no hay servidores.",
  memberSingular:                     "miembro",
  channelsHeading:                    "Canales",
  membersHeading:                     "Miembros",
  createServerBtn:                    "+ Crear servidor",
  createServerTitle:                  "Crear servidor",
  createServerIntro:                  "Crea un centro con canales para tu comunidad.",
  createServerNameLabel:              "Nombre",
  createServerNamePlaceholder:        "ej. Mi Clan",
  createServerDescLabel:              "Descripción (opcional)",
  createServerDescPlaceholder:        "¿De qué trata?",
  createServerSubmitBtn:              "Crear servidor",
  createServerNameRequired:           "El nombre es obligatorio",
  createServerNameTooLong:            "Nombre demasiado largo (máx. 80 caracteres)",
  createServerSuccess:                "✅ Servidor creado",
  createServerFailed:                 "Error al crear",
  createServerLimitReached:           "Límite de servidores alcanzado (máx. {limit}).",
  tooManyRequests:                    "Demasiadas solicitudes — espera un momento.",
  creating:                           "Creando…",
  leaveServerBtn:                     "Abandonar servidor",
  leaveServerConfirm:                 "¿Abandonar el servidor „{name}\"?",
  leaveServerOwnerConfirm:            "Eres el propietario. Si existen otros miembros, debes transferir primero. ¿Intentar de todas formas?",
  leaveServerOwnerTransferRequired:   "⚠ Transfiere la propiedad a otro miembro primero.",
  leaveServerFailed:                  "Error al abandonar",
  serverDeletedToast:                 "🗑 Servidor eliminado (eras el único propietario)",
  serverLeftToast:                    "👋 Servidor abandonado",
  channelSendNotReady:                "📡 Los mensajes de canal llegarán en la fase 4b.",

  // ── Configuración del servidor + Editor de roles (Fase 3A.5) ────────
  serverSettingsBtn:        "Configuración del servidor",
  serverSettingsTitle:      "Configuración del servidor",
  tabRoles:                 "Roles",
  tabMembers:               "Miembros",
  rolesReadOnly:            "👁 Solo lectura — necesitas MANAGE_ROLES para editar roles.",
  membersReadOnly:          "👁 Solo lectura — necesitas MANAGE_ROLES para cambiar roles de miembros.",
  tabChannels:              "Canales",
  channelsAutoDeleteReadOnly: "👁 Solo lectura — necesitas MANAGE_CHANNELS para cambiar el auto-borrado.",
  channelsAutoDeleteHint:   "El auto-borrado elimina los mensajes del canal tras el periodo definido para todos los miembros. Todos reciben un mensaje del sistema.",
  // ── Phase 3A.5: Pestaña General (icono del servidor + nombre/descripción) ──
  tabGeneral:               "General",
  iconSectionTitle:         "Icono del servidor",
  iconChooseBtn:            "Elegir imagen",
  iconRemoveBtn:            "Eliminar",
  iconRemoveConfirm:        "¿Eliminar el icono del servidor?",
  iconHint:                 "PNG, JPEG o WebP — máx. 1 MB. Subida automática al seleccionar.",
  iconErrorMime:            "Solo PNG, JPEG o WebP",
  iconErrorSize:            "Archivo demasiado grande (máx. 1 MB)",
  iconUploadedToast:        "✅ Icono del servidor actualizado",
  iconRemovedToast:         "🗑 Icono del servidor eliminado",
  iconUploadFailed:         "Subida del icono fallida",
  iconRemoveFailed:         "Eliminación fallida",
  profileSectionTitle:      "Nombre y descripción",
  serverNameLabel:          "Nombre",
  serverDescLabel:          "Descripción",
  nameRequired:             "El nombre no puede estar vacío",
  serverSavedToast:         "✅ Configuración del servidor guardada",
  // ── Phase 3A.5: Sistema de bans ─────────────────────────
  tabBanned:                "Baneados",
  banBtn:                   "Banear",
  banConfirm:               "¿Banear realmente a @{handle}? Será expulsado de inmediato y no podrá volver por invitación.",
  banReasonPrompt:          "Motivo (opcional, dejar vacío si ninguno):",
  bannedToast:              "🚫 @{handle} baneado",
  banFailed:                "Baneo fallido",
  unbanBtn:                 "Desbanear",
  unbanConfirm:             "¿Levantar el ban de @{handle}? Podrá volver a unirse por invitación.",
  unbannedToast:            "✅ Ban de @{handle} levantado",
  unbanFailed:              "Desbaneo fallido",
  bansEmpty:                "Sin bans activos en este servidor.",
  bansHint:                 "🚫 Los usuarios baneados no pueden volver por invitación. Desbanear lo permite.",
  bannedByLabel:            "Baneado por",
  cannotBanOwner:           "No se puede banear al propietario",
  cannotBanSelf:            "No puedes banearte a ti mismo",
  bannedFromServerToast:    "Has sido baneado del servidor",
  // ── Phase 3A.5: Canales privados ──────────────────────
  tabPermissions:           "Permisos",
  privateBadge:             "privado",
  privateChannelToggle:     "Canal privado",
  privateOnHint:            "Solo los miembros con acceso explícito (abajo) ven este canal. Propietario + ADMINISTRADOR siempre lo ven.",
  privateOffHint:           "Todos los miembros del servidor ven este canal.",
  accessListTitle:          "Quién tiene acceso",
  accessEmpty:              "Nadie con acceso explícito aún — solo Propietario + ADMINISTRADOR ven el canal.",
  addRoleSelect:            "+ Añadir rol…",
  addMemberSelect:          "+ Añadir miembro…",
  channelName:              "Nombre",
  channelTopic:             "Tema",
  channelEditHint:          "Haz clic para editar (nombre, tema, permisos)",
  channelSavedToast:        "✅ Canal guardado",
  remove:                   "Eliminar",
  add:                      "Añadir",
  loading:                  "Cargando…",
  // ── Phase 3A.5: Límites por nivel ─────────────────────
  createServerLimitReachedFree: "Límite de servidores alcanzado (máx {limit} como propietario Free). Actualiza a Pro para {proLimit}.",
  createServerLimitReachedPro:  "Límite de servidores alcanzado (máx {limit} como propietario Pro).",
  // ── Phase 5-Light: Turnstile + ServerJoinModal ────────
  joining:                  "Uniéndose…",
  inviteJoinTitle:          "Invitación de servidor",
  inviteJoinBtn:            "Unirse",
  inviteFrom:               "de @{handle}",
  inviteMemberCount:        "{count} miembros",
  inviteUserBanned:         "Has sido baneado de este servidor y no puedes unirte.",
  inviteServerFull:         "Servidor lleno.",
  inviteExpired:            "Enlace de invitación caducado.",
  inviteUsedUp:             "Enlace de invitación ya utilizado.",
  roleCreateBtn:            "Crear rol",
  roleCreateTitle:          "Crear rol",
  roleEditTitle:            "Editar rol",
  roleDefault:              "predeterminado",
  roleDefaultLocked:        "Rol predeterminado — no se puede quitar",
  roleDefaultHint:          "🛡 Rol predeterminado „everyone\" — nombre y posición fijos. Permisos editables.",
  roleEdit:                 "Editar",
  roleAssign:               "Asignar",
  roleRevoke:               "Quitar",
  roleNameLabel:            "Nombre",
  roleNamePlaceholder:      "ej. Moderador",
  roleNameRequired:         "El nombre es obligatorio",
  roleNameTooLong:          "Nombre demasiado largo (máx. 64 caracteres)",
  roleColorLabel:           "Color",
  rolePositionLabel:        "Posición",
  roleMentionableLabel:     "@-mención permitida (ej. @Moderador)",
  roleCreated:              "✅ Rol creado",
  roleUpdated:              "✅ Rol actualizado",
  roleDeleted:              "🗑 Rol eliminado",
  roleDeleteConfirm:        "¿Eliminar rol „{name}\"?",
  owner:                    "Propietario",
  permissionsHeading:       "Permisos",
  permGroupGeneral:         "General",
  permGroupModeration:      "Moderación",
  permGroupServer:          "Gestión del servidor",
  permGroupVoice:           "Voz (Fase 8)",
  permGroupAdmin:           "⚠ Super-Admin",
  permViewChannel:          "Ver canales",
  permSendMessages:         "Enviar mensajes",
  permMentionEveryone:      "Mencionar @everyone",
  permManageMessages:       "Eliminar/anclar mensajes",
  permKickMembers:          "Expulsar miembros",
  permBanMembers:           "Bannear miembros (Fase 3A.5)",
  permManageChannels:       "Gestionar canales",
  permManageRoles:          "Gestionar roles",
  permManageServer:         "Cambiar configuración del servidor",
  permInviteMembers:        "Invitar miembros",
  permVoiceConnect:         "Unirse a canal de voz",
  permVoiceSpeak:           "Hablar en canal de voz",
  permAdministrator:        "ADMINISTRATOR — omite todas las verificaciones de permisos",
  permAdminOwnerOnly:       "solo propietario",
  errForbiddenManageRoles:  "Sin permiso (MANAGE_ROLES)",
  errForbiddenRolePosition: "Posición demasiado alta — solo puedes gestionar roles por debajo del tuyo",
  errForbiddenAdminBit:     "Solo el propietario puede activar el bit ADMINISTRATOR",
  errCannotDeleteDefault:   "El rol predeterminado no se puede eliminar",
  errReservedName:          "Nombre reservado (everyone)",
  create:                   "Crear",
  save:                     "Guardar",
  saving:                   "Guardando…",
  delete:                   "Eliminar",
  error:                    "Error",

  // ── Gestión de Passkeys ──────────────────────────────
  passkeysLabel:           "Passkeys",
  passkeysTitle:           "Gestionar Passkeys",
  passkeyAdd:              "+ Añadir Passkey",
  passkeyAdding:           "Creando Passkey…",
  passkeyAdded:            "Passkey añadido",
  passkeyAddFailed:        "No se pudo añadir el Passkey",
  passkeyDelete:           "Eliminar",
  passkeyDeleteConfirm:    "¿Eliminar este Passkey?",
  passkeyDeleteLast:       "No se puede eliminar el último Passkey",
  passkeyDeleted:          "Passkey eliminado",
  passkeyDeleteFailed:     "No se pudo eliminar el Passkey",
  passkeyRename:           "Renombrar",
  passkeyRenamePlaceholder: "ej. iPhone, MacBook…",
  passkeyRenamed:          "Passkey renombrado",
  passkeyRenameFailed:     "Error al renombrar",
  passkeyCreated:          "Creado",
  passkeyLastUsed:         "Último uso",
  passkeyNeverUsed:        "Nunca usado",
  passkeyUnnamed:          "Sin nombre",
  passkeyLoadFailed:       "No se pudieron cargar los Passkeys",
  passkeyNamePrompt:       "Nombre para este Passkey (opcional):",

  // ── Empty States ─────────────────────────────────────
  selectChatHint:      "Selecciona un chat",
  noCallsYet:          "Sin llamadas aún",
  openChatForCall:     "Abre un chat y toca 📞 arriba",

  // ── Locale ───────────────────────────────────────────
  locale: "es-ES",

  // ── Push Notifications ──────────────────────────────
  pushBannerTitle:      "Activar notificaciones",
  pushBannerSubtitle:   "No te pierdas ningún mensaje",
  pushBannerActivating: "Activando…",
  pushBannerBlocked:    "Notificaciones bloqueadas",

  // ── Debug / Diagnóstico ─────────────────────────────
  debugLabel:  "Debug / Diagnóstico",
  debugTitle:  "Debug / Diagnóstico",
  debugHint:   "Consejo: Bloquea tu teléfono después de \"Enviar test push\" y espera 5-10 segundos. Si ves una notificación → las notificaciones funcionan. Si no: comprueba el estado arriba + copia el resultado al portapapeles.",

  // ── Banner de actualización de versión ──────────────
  newVersionAvailable: "Nueva versión disponible",
  reloadNow:           "Actualizar ahora",
  dismissBtn:          "Cerrar",
};
